import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { CatalogChangesScreen } from './CatalogChangesScreen';
import type { CatalogChangesSearch } from './catalog-changes-search';

const route = getRouteApi('/catalog-changes');

export function CatalogChangesRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: CatalogChangesSearch) => {
      void navigate({
        replace: true,
        search: () => ({
          ...(next.kind === undefined ? {} : { kind: next.kind }),
          ...(next.actor === undefined ? {} : { actor: next.actor }),
          ...(next.window === undefined ? {} : { window: next.window }),
          ...(next.q === undefined ? {} : { q: next.q }),
          ...(next.event === undefined ? {} : { event: next.event }),
        }),
      });
    },
    [navigate],
  );

  return <CatalogChangesScreen search={search} onSearchChange={onSearchChange} />;
}
